import { render } from "./SettingsTabApi.vue?vue&type=template&id=1a08da13"
import script from "./SettingsTabApi.vue?vue&type=script&lang=js"
export * from "./SettingsTabApi.vue?vue&type=script&lang=js"

import "./SettingsTabApi.vue?vue&type=style&index=0&id=1a08da13&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__